import { useNavigate } from "react-router-dom";
import { HeaderTitle, HeaderWrapper } from "./style";
import { useSetRecoilState } from "recoil";
import { loginState } from "../../recoil/auth.atom";
import {
  LOCAL_STORAGE_ACCESS_KEY,
  LOCAL_STORAGE_SUPER_ADMIN_KEY,
} from "../../utils/network";

export interface HeaderButtonProps {
  name: string;
  onClick: () => void;
}

export interface HeaderProps {
  show?: boolean;
  title: string;
  back?: () => void;
  button?: HeaderButtonProps;
}

const MobileHeader = ({ show, title, back, button }: HeaderProps) => {
  const navigate = useNavigate();
  const setIsLoggedIn = useSetRecoilState(loginState);

  const handleLogout = () => {
    const confirm = window.confirm("로그아웃 하시겠습니까?");
    if (!confirm) return;
    localStorage.removeItem(LOCAL_STORAGE_ACCESS_KEY);
    localStorage.removeItem(LOCAL_STORAGE_SUPER_ADMIN_KEY);
    setIsLoggedIn(false);
    navigate("/login");
  };

  return (
    <HeaderWrapper show={show || false}>
      <HeaderTitle show={show || false}>
        <img
          alt="back"
          src={`/image-web/icon/Back${show ? "_white" : ""}.svg`}
          onClick={() => (back ? back() : handleLogout())}
        />
        <div className="name">{title}</div>
      </HeaderTitle>
      {button && (
        <div className="button" onClick={button.onClick}>
          {button.name}
        </div>
      )}
    </HeaderWrapper>
  );
};

export default MobileHeader;
